import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const EmptyState = ({ text, linkUrl, buttonText }) => {
    const { t } = useTranslation();
    return (
        <div style={{
            height: '200px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '1rem',
        }}>
            <div style={{
                color: '#64748b',
                fontStyle: 'italic',
            }}>
                {text}
            </div>

            {linkUrl ? (
                <Link to={linkUrl} style={{
                    display: 'inline-block',
                    padding: '0.75rem 1.5rem',
                    backgroundColor: '#3b82f6',
                    color: '#fff',
                    borderRadius: '12px',
                    textDecoration: 'none',
                    fontWeight: '600',
                    transition: 'all 0.2s',
                    cursor: 'pointer',
                }}>
                    {buttonText || t('mypage.results.start_test')}
                </Link>
            ) : null}
        </div>
    );
};

export default EmptyState;
